<div id="standard-modal" role="dialog" aria-labelledby="standard-modalLabel">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title" id="standard-modalLabel">
          {{ (isNew ? 'tabulation.modal.addAction' : 'tabulation.modal.editAction') | translate }} {{ 'tabulation.modal.closingReasonTitle' | translate }}
        </h4>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-hidden="true"
          (click)="close()"
        ></button>
      </div>

      <div class="modal-body">
        <form [formGroup]="formGroup" class="w-100 col-lg-10">
          <div class="row">
            <div class="col-12 mb-3">
              <label class="form-label">{{ 'tabulation.modal.channelLabel' | translate }}</label>
              <mat-select
                formControlName="channel"
                class="form-control"
                [placeholder]="'tabulation.modal.channelPlaceholder' | translate"
              >
                @for (item of listChannel; track item) {
                <mat-option [value]="item._id">{{ item.name }}</mat-option>
                }
              </mat-select>
              <field-error-component
                [field]="'channel'"
                [label]="'tabulation.modal.channelFieldLabel' | translate"
                [formGroup]="formGroup"
              />
            </div>

            <div class="col-12 mb-3">
              <label class="form-label">{{ 'tabulation.modal.nameLabel' | translate }}</label>
              <input
                class="form-control"
                formControlName="name"
                [placeholder]="'tabulation.modal.namePlaceholder' | translate"
                maxlength="100"
                required
              />
              <field-error-component
                [field]="'name'"
                [label]="'tabulation.modal.nameFieldLabel' | translate"
                [formGroup]="formGroup"
              />
            </div>

            <div class="col-12 mb-3">
              <label class="form-label">{{ 'tabulation.modal.descriptionLabel' | translate }}</label>
              <textarea
                [rows]="3"
                [cols]="50"
                class="form-control"
                formControlName="description"
                [placeholder]="'tabulation.modal.descriptionPlaceholder' | translate"
              >
              </textarea>
            </div>
          </div>
        </form>
      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-light" (click)="close()">
          {{ 'tabulation.modal.cancelButton' | translate }}
        </button>
        <button
          class="btn btn-primary"
          (click)="save()"
          [disabled]="loading || formGroup.invalid"
        >
          @if (loading) {
          <mat-spinner [diameter]="25" mode="indeterminate" class="px-3" />
          } @else {
          {{ (isNew ? 'tabulation.modal.saveButton' : 'tabulation.modal.editAction') | translate }}
          }
        </button>
      </div>
    </div>
  </div>
</div>
